import axios from "axios";
import { getSearchTextParts } from "functions/getSearchTextParts";
import { eHierarchy, eHierarchyLevel } from "../enums";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { HierarchyLink } from "../tlfItem/TlfItemIndexReadDto";

export interface HierarchySearchDto {
  id: string;
  name: string;
  description: string | null;
  hierarchyTag: string;
  parentTag: string;
  level: eHierarchyLevel;
  type: eHierarchy;
  isBackupVersion: boolean;
  tocMajorVersion?: number;
  hierarchyLinks: HierarchyLink[];
}

export type HierarchyReadDtoSearchReturn = IAxiosReturn<HierarchySearchDto[]>;

/**
 * Search hierarchies by name or metadata.
 *
 * @param backEndUrl - Base backend URL
 * @param searchText - Text to search for
 * @param controller - AbortController to cancel the request
 * @returns List of matching hierarchies wrapped in HierarchyReadDtoSearchReturn
 */
export const searchAllHierarchies = async (
  backEndUrl: string,
  searchText: string,
  controller: AbortController,
): Promise<HierarchyReadDtoSearchReturn> => {
  const url = new URL(`${backEndUrl}Hierarchy/Search`);
  // Get data
  try {
    const searchTextParts = getSearchTextParts(searchText);
    searchTextParts.forEach((searchTextPart) => {
      url.searchParams.append("searchText", searchTextPart);
    });
    const response: { data: HierarchySearchDto[] } = await axios.get(url.href, {
      signal: controller.signal,
    });
    // Return successful result
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Search all hierarchies failed", error);
  }
};
